export const useAppNoticeController = () => {
  // TODO: Add logic to get the app notice from the backend
  const title = "App Notice";
  const description = "This is the description of the app notice";
  const url = "https://kyan.blue";
  const isInvisible = true;

  const handleClick = () => {
    window.open(url, "_blank");
  };

  return {
    title,
    description,
    isInvisible,
    handleClick,
  };
};
